import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import MmcwLogo from '@propertypal/shared/src/resources/logos/millar-mccall-wylie-logo.svg';
import styled, { css } from 'styled-components';
import { Container as ButtonContainer } from '../buttons/Button.style';
import { CheckLabel } from '../inputs/CheckItem.style';

export const Form = styled.form<{ $loading: boolean }>`
  ${({ $loading }) =>
    $loading
      ? css`
          pointer-events: none;
          opacity: 0.5;
        `
      : ''}

  ${ButtonContainer}:disabled {
    background: #d5d5d5;
  }
`;

export const FormItemContainer = styled.div`
  margin-top: 20px;
`;

export const FormItemOptions = styled.div<{ bool?: boolean }>`
  display: grid;
  grid-template-columns: repeat(${({ bool }) => (bool ? 6 : 3)}, minmax(0, 1fr));
  grid-gap: 10px;

  ${CheckLabel} {
    border: solid 1px ${({ theme }) => theme.backgroundLight};
    font-weight: 600;
  }

  @media (${mobileXXLargeMax}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 350px) {
    grid-template-columns: repeat(${({ bool }) => (bool ? 2 : 1)}, minmax(0, 1fr));
  }
`;

export const FormInputContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 10px;

  @media (${mobileXXLargeMax}) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

export const LogoContainer = styled.div`
  margin: 0 auto;
  max-width: 100px;
  width: 100%;
`;

export const Logo = styled(MmcwLogo)`
  width: 100%;
`;
